import Dialog from "@mui/material/Dialog";
import { Alert, Button, Stack, TextField, Box } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useContext, useState } from "react";
import AppContext from "../../contexts/AppContext";
import CharacterSelecter from "../textfields/CharacterSelecter";
import RaidSelecter from "../textfields/RaidSelecter";
import apiFetch from "../../helperFunctions/api";
import useAsyncAction from "../../helperFunctions/useAsyncAction";


export default function ManualAttendanceEntry() {
  const [open, setOpen] = useState(false);
  const [raid_team, setRaidTeam] = useState('');
  const [character_name, setCharacter] = useState('');
  const item = "Attendance DKP";
  const itemId = 0;
  const [dkp, setDkp] = useState('');
  let {API, setLedgerData, getCharacters} = useContext(AppContext);
  const { pending, error, run, clearError } = useAsyncAction();
  const title = "Manually Add Attendance?";

  const handleClickOpen = () => {
    clearError();
    setOpen(true);
  };

  const handleClose = () => {
    if (pending) return;
    setOpen(false);
    setRaidTeam('')
    setCharacter('')
    setDkp('')
  }

  const postAddItem = (update) => run(async () => {

    let body = { update, action: "ADD_ITEM" };

    body = JSON.stringify(body);

    const response = await apiFetch(`${API}/ledger`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body,
    });
    setLedgerData(await response.json());
    getCharacters();
    setOpen(false);
    setRaidTeam("");
    setCharacter("");
    setDkp("");
  });

  const actionButton = () => <Button disabled={pending || !character_name || !/^-?\d+$/.test(dkp)}
    onClick={() => postAddItem({character_name, dkp, itemId, item, raid_team})}>{pending ? "Saving..." : "Confirm"}</Button>;

  return (
    <Box sx={{ textAlign: "center" }}>
      <Button size="small" onClick={() => handleClickOpen()}>
        Add Manual Attendance Entry
      </Button>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          {error && <Alert severity="error">{error}</Alert>}
          <DialogContentText component="div" sx={{ mt: 1 }}>
            <Stack spacing={2}>
              <RaidSelecter valueGetter={{setRaidTeam}} />
              <CharacterSelecter valueGetter={{ setCharacter }} />
              <TextField
                label={"Item"}
                defaultValue={item}
                disabled
              />
              <TextField
                label={"Item ID"}
                defaultValue={itemId}
                disabled
              />
              <TextField
                label={"DKP Amount"}
                defaultValue={dkp}
                onChange={(e) => setDkp(e.target.value)}
                type="number"
              />
            </Stack>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button disabled={pending} onClick={() => handleClose()}>Cancel</Button>
          {actionButton()}
        </DialogActions>
      </Dialog>
    </Box>
  );
}
